import https from '../http';
const common = {
	/*文件上传*/
	uploadFile: function(params) {
		return https.post('/common/upload', params)
	},
	/*获得解密后的数据*/
	decodeData: function(params) {
		return https.post('/decode/data_decode', params)
	},
	/* 百度语音接口*/
	baiduVoice: function(params) {
		return https.post('/bdtts/index', params)
	},

	/*学习时长*/
	learnTime: function(params) {
		return https.post('/userstudyduration/add_studyduration_time', params)
	},

	/*发送验证码*/
	sendSms: function(params) {
		return https.post('/sms/send', params)
	},

	/*校验验证码*/
	checkSms: function(params) {
		return https.post('/sms/check', params)
	},

	/*注册会员*/
	siginUser: function(params) {
		return https.post('/user/register', params)
	},

	/*验证激活码*/
	checkActiveCode: function(params) {
		return https.post('/activationcode/activation', params)
	},
	/*手机号码登录*/
	loginPhone: function(params) {
		return https.post('/user/authenticationcodelogin', params)
	},

	/*获取课文朗读语音*/
	getCourseAudio: function(params) {
		return https.post('/bdtts/index', params)
	},

	/*单词集中突破*/
	getWordBreakThrough: function(params) {
		return https.get('/specialenglishtraining/get_wordsetall', params)
	},

	/*单词集中突破 练习*/
	getWordBreakThroughTest: function(params) {
		return https.get('/specialenglishtraining/get_practices', params)
	},
	/*单词集中突破 记录当前索引*/
	setwordcord: function(params) {
		return https.post('/wordrecord/setwordcord', params)
	},
	// 获取学习记录数
	getuserwordnum: function(params) {
		return https.get('/specialenglishtraining/getuserwordnum', params)
	},
	/*获取年份下的城市*/
	getPaperCitys: function(params) {
		return https.get('/papers/getpapecitys', params)
	},

	/*获取学习记录 new*/
	getUserLearnings: function(params) {
		return https.post('/userlearning/getUserLearnings', params)
	},
	/*获取banner图接口*/
	getbannerlist: function(params) {
		return https.get('/banner/getbannerlist', params)
	},
	/*获取课本列表接口*/
	getbook: function(params) {
		return https.get('/book/getbook', params)
	},
	// 获取课本章节接口
	getbookchapterlist: function(params) {
		return https.get('/book/getbookchapterlist', params)
	},
	// 获取章节最后一层接口
	getlastchapterlist: function(params) {
		return https.get('/book/getlastchapterlist', params)
	},
	// 获取版本列表接口
	getversionlist: function(params) {
		return https.get('/version/getversionlist', params)
	},
	// 保存版本接口

	setversion: function(params) {
		return https.get('/version/setversion', params)
	},

	// 获取商品列表接口
	getshoplist: function(params) {
		return https.get('/shop/getshoplist', params)
	},
	// 兑换商品接口
	exchangeshop: function(params) {
		return https.post('/shop/exchangeshop', params)
	},
	// 我的礼品屋列表接口
	getusershop: function(params) {
		return https.get('/shop/getusershop', params)
	},
	// 添加收货地址接口
	setaddress: function(params) {
		return https.post('/useraddress/setaddress', params)
	},
	// 获取收货地址列表接口
	getaddress: function(params) {
		return https.get('/useraddress/getaddress', params)
	},
	// 删除收货地址接口
	deladdress: function(params) {
		return https.get('/useraddress/deladdress', params)
	},
	// 编辑收货地址接口
	editaddress: function(params) {
		return https.post('/useraddress/editaddress', params)
	},
	// 获取同步课堂接口
	getvideolist: function(params) {
		return https.post('/video/getvideolist', params)
	},
	// 获取试题接口
	getquestionlist: function(params) {
		return https.get('/question/getquestionlist', params)
	},
	// 获取错题列表接口
	getwrongquestionlist: function(params) {
		return https.get('/question/getwrongquestionlist', params)
	},
	// 添加错题接口
	addwrongquestion: function(params) {
		return https.get('/question/addwrongquestion', params)
	},
	// 删除错题接口
	delwrongquestion: function(params) {
		return https.get('/question/delwrongquestion', params)
	},
	// 获取微信客服接口
	getservicewechat: function(params) {
		return https.get('/servicewechat/getservicewechat', params)
	},
	// 设置闯关模式接口
	setmode: function(params) {
		return https.get('/user/setmode', params)
	},
	// 学分兑换芯币接口
	scoretocoin: function(params) {
		return https.post('/scoretocoin/scoretocoin', params)
	},
	// 新增学分
	addscore: function(params) {
		return https.post('/scoretocoin/addscore', params)
	},
	// 获取学分列表接口
	getscorelist: function() {
		return https.get('/scoretocoin/getscorelist')
	},
	// 获取芯币记录接口
	getcoinlist: function() {
		return https.get('/scoretocoin/getcoinlist')
	},
	// 添加学习记录接口
	setstudyreport: function(params) {
		return https.post('/studyreport/setstudyreport', params)
	},
	// 获取学习报告接口
	getstudyreport: function() {
		return https.get('/studyreport/getstudyreport')
	},
	// 获取协议接口
	getagreement: function() {
		return https.get('/agreement/getagreement')
	},
	// 完善用户资料接口
	profile: function(params) {
		return https.post('/user/profile', params)
	},
	// 
	getmodulelist: function() {
		return https.get('/module/getmodulelist')
	},
	getmodulechapterlist: function(params) {
		return https.get('/module/getmodulechapterlist', params)
	},
	getmobilemodulechapterlist: function(params) {
		return https.get('/module/getmobilemodulechapterlist', params)
	},
	// 获取内容接口
	getcontent: function(params) {
		return https.get('/content/getcontent', params)
	}
};

export default common